var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[(_vm.type === 'single')?_c('Single'):(_vm.type === 'multi')?_c('Multi'):(_vm.type === 'conference')?_c('conference'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }